"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_SEARCH = exports.MY_SHOP = exports.STORE_FOLLOW = exports.STORE_DETAIL = exports.STORE = void 0;
exports.STORE = 'STORE';
exports.STORE_DETAIL = 'STORE_DETAIL';
exports.STORE_FOLLOW = 'STORE_FOLLOW';
exports.MY_SHOP = 'MY_SHOP';
exports.STORE_SEARCH = 'STORE_SEARCH';
var PAGES_MAP = (_a = {},
    _a[exports.STORE] = '/profile/store',
    _a[exports.STORE_DETAIL] = '/profile/store/detail',
    _a[exports.STORE_FOLLOW] = '/profile/store/follow',
    _a[exports.STORE_SEARCH] = '/profile/store/search',
    _a[exports.MY_SHOP] = '/myShop',
    _a);
exports.default = PAGES_MAP;
